import {
    type ViewStyle,
    type TextStyle,
    StyleSheet
} from "react-native";
import type {
    ChartTooltipDynamicStyleType
} from "./type";
import type {
    Mutable
} from "../../../../types";
import {
    getSurfaceStyle
} from "../../../../helpers/theme/elevation";
import {
    getCornerStyle
} from "../../../../helpers/theme/corner";

const stylesheet = StyleSheet.create({
    container: {
        alignSelf: "flex-start",
        pointerEvents: "none"
    },
    row: {
        alignItems: "center",
        flexDirection: "row"
    },
    value: {
        fontVariant: [
            "tabular-nums"
        ]
    },
    name: {
        flexShrink: 1,
        flexGrow: 1
    }
});

export const useStyles = ({
    controlPaddings,
    shapeConfigs,
    shadowAlpha,
    elevations,
    iconSizes,
    radiuses,
    borders,
    colors,
    spaces
}: ChartTooltipDynamicStyleType) => {
    const styles = {
        divider: {
            backgroundColor: colors.content.border.subtle,
            height: borders.separator
        } as Mutable<ViewStyle>,
        container: {
            ...getSurfaceStyle({
                surface: "popover",
                shadowAlpha,
                elevations,
                borders,
                colors
            }),
            minWidth: shapeConfigs.chartTooltipMinWidth,
            paddingHorizontal: controlPaddings.small,
            maxWidth: shapeConfigs.tooltipMaxWidth,
            paddingVertical: spaces.spacingSm,
            ...getCornerStyle({
                radius: radiuses.form,
                shapeConfigs
            }),
            gap: spaces.spacingXs
        } as Mutable<ViewStyle>,
        value: {
            marginStart: spaces.spacingMd
        } as Mutable<TextStyle>,
        row: {
            minHeight: iconSizes.large,
            gap: spaces.spacingSm
        } as Mutable<ViewStyle>
    };

    return styles;
};
export default stylesheet;
